import React from "react";
import classes from "./PageMain.module.scss";

interface Interface {
  children?: any;
  // no required
  className?: any;
  center?: any;
  left?: any;
  right?: any;
  centerStretch?: any;
  isolate?: any;
  warning?: any;
}
export default function PageMain({
  className = "",
  center = null,
  centerStretch = null,
  left = null,
  right = null,
  children = null,
  isolate = null,
  warning = null,
}: Interface) {
  className += " " + classes.PageMain;
  if (left) className += " " + classes.Left;
  if (right) className += " " + classes.Right;
  if (center) className += " " + classes.Center;
  if (isolate) className += " " + classes.Isolate;
  if (warning) className += " " + classes.Warning;
  if (centerStretch) className += " " + classes.Center + " " + classes.Stretch;
  return <main className={className.main}>{children}</main>;
}
